<template>
  <voxy-dropdown
    :class="['org-manager-teacher-filter', isActive && 'org-manager-teacher-filter_active']"
    ref="dropdown"
    menu-alignment="right"
    @on-open="isOpen = true"
    @on-close="isOpen = false"
  >
    <span slot="button" class="org-manager-teacher-filter__icon">
      <font-awesome-icon :icon="['fas', 'school']" />
    </span>
    <div class="org-manager-teacher-filter__dropdown">
      <div class="org-manager-teacher-filter">
        <ul class="org-manager-teacher-filter__options">
          <li class="org-manager-teacher-filter__option" v-for="(option, index) in organizations" :key="index">
            <voxy-radio
              class="org-manager-teacher-filter__radio"
              name="org-manager-teacher-filter"
              v-model="model"
              :value="option.id"
            >
              {{ option.name }}
            </voxy-radio>
          </li>
        </ul>
      </div>
    </div>
  </voxy-dropdown>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { VoxyDropdown, VoxyRadio } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'OrgsTeacherManagerFilter',

  components: {
    FontAwesomeIcon,
    VoxyDropdown,
    VoxyRadio,
  },

  data() {
    return {
      isOpen: false,
      key: null,
    };
  },

  mounted() {
    this.key = this.filterByOrg || this.organizationId;
    this.model = this.key;
  },

  computed: {
    ...mapGetters(['organizations', 'organizationId']),
    ...mapState('manageTeachers', ['filterByOrg']),

    isActive() {
      return this.isOpen || this.key !== null;
    },

    model: {
      get() {
        return this.key || null;
      },
      set(value) {
        this.$store.commit('SET_ORGANIZATION_ID', { organizationId: value });
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      applyFilter: 'SEARCH_BY_ORG',
    }),

    close() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.close();
      }
    },
  },

  watch: {
    organizationId(value) {
      this.key = value;
      this.applyFilter(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.org-manager-teacher-filter {
  &__icon {
    font-size: 21px;
    display: inline-flex;
    width: 1.5rem;
    justify-content: center;
    align-items: center;

    .org-manager-teacher-filter_active & {
      color: $default-blue;
    }
  }

  &__dropdown {
    min-width: 230px;
    padding: 15px 10px 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
    background-color: #515151;
    border-radius: 5px;
  }

  &__options {
    max-height: 22rem;
    margin: 0;
    padding: 4px 12px;
    overflow-y: auto;
  }

  &__option {
    display: flex;
    line-height: 1.5em;
    align-items: center;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 13px;
    }

    input {
      font-size: 100%;
      width: 2em;
      height: auto;
      margin: 0 10px;
      padding: 0;
      color: white;
      text-align: center;
      border-bottom: 1px solid rgba(white, 0.5);
    }

    .voxy-radio__label {
      display: inline-flex;
      align-items: center;
      text-transform: none;
    }
  }

  &__radio {
    font-size: 13px;
    cursor: pointer;

    ::v-deep {
      .voxy-radio__label {
        font-weight: 500;
      }

      .voxy-radio__box {
        width: 12px;
        height: 12px;
        border-color: white;

        &::before {
          top: 2px;
          right: 2px;
          bottom: 2px;
          left: 2px;
        }
      }
    }
  }
}
</style>
